import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import arquivo2 from "src/assets/relatorio_de_igualdade_salarial_2026_01.pdf";
import arquivo3 from "src/assets/relatorio_de_igualdade_salarial_2026_02.pdf";
import arquivo4 from "src/assets/relatorio_de_sustentabilidade_ambiental_e_social_2025.pdf";

import VisibilitySensor from "react-visibility-sensor";

import logo from "src/assets/icon/logo.png"

function Footer() {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <VisibilitySensor onChange={onChange} partialVisibility minTopValue={100}>
      <div className={`footer-bg-lp ${isVisible ? "visible" : ""}`}>
        <div className="footer">
          <div className="logo">
            <img
              className={`${isVisible ? "visible" : ""}`}
              src={logo}
              alt="Logotipo da empresa"
              width={"250px"}
            />
            <div className={`line ${isVisible ? "visible" : ""}`}></div>
          </div>
          <div className={`address ${isVisible ? "visible" : ""}`}>
          <p className={`address ${isVisible ? 'visible' : ''}`}>GH OPERADOR LOGISTICO LTDA - 07.656.322/0001-32</p>
          </div>
          <div className={`rights ${isVisible ? "visible" : ""}`}>
            <p>
              {t("footer_rights")}
            </p>
          </div>
          <div className={`singlec ${isVisible ? "visible" : ""}`}>
            <p>
              <a
                href={arquivo2}
                target="_blank"
                rel="noreferrer"
                download="relatorio_de_igualdade_salarial_2026_semestre_01.pdf"
              >
                {t("footer_equality1_link")}
              </a>
            </p>
            <p>
              <a
                href={arquivo3}
                target="_blank"
                rel="noreferrer"
                download="relatorio_de_igualdade_salarial_2026_semestre_02.pdf"
              >
                {t("footer_equality2_link")}
              </a>
            </p>
            <p>
              <a
                href={arquivo4}
                target="_blank"
                rel="noreferrer"
                download="relatorio_de_sustentabilidade_ambiental_e_social_2025.pdf"
              >
                {t("footer_sustainability_link")}
              </a>
            </p>
          </div>
          <div className={`singlec ${isVisible ? "visible" : ""}`}>
            <p>
              A product developed by{" "}
              <a
                href="https://singlec.com.br/"
                target="_blank"
                rel="noreferrer"
              >
                Singlec
              </a>
            </p>
          </div>
        </div>
      </div>
    </VisibilitySensor>
  );
}

export default Footer;
